/**
 * Denis Callinan
 * Project Andromeda
 * July 31st, 2020
 * App.js - Pulling it all together
 */

import React from 'react';
import Favicon from 'react-favicon';
import './App.css';

// Favicon
import fav from './img/favicon.ico';

// Navbar component
import Navbar from './components/Navbar/Navbar.js';

// Sections
import Header from './sections/Header.js';
import AboutMe from './sections/AboutMe.js';
import Education from './sections/Education.js';
import Experience from './sections/Experience.js';
import Portfolio from './sections/Portfolio.js';
import Contact from './sections/Contact.js';
import Footer from './components/Footer/Footer.js';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollPos: window.scrollY,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      mWindowEnabled: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    if (!this.state.mWindowEnabled) {
      this.setState({ mWindowEnabled: true});
    } else {
      this.setState({ mWindowEnabled: false});
    }
  }

  handleResize = (e) => {
    this.setState({ 
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      mWindowEnabled: false ,
    });
  };

  handleScroll = (e) => {
    this.setState({ scrollPos: window.scrollY });
  }
  
  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
  }

  render() {
    return (
      <div className = "App">
        <Favicon url={fav}/>
        <Navbar state = {this.state} handle = {this.handleClick}/>
        <Header />
        <AboutMe state = {this.state} />
        <Education state = {this.state} />
        <Experience state = {this.state} />
        <Portfolio state = {this.state} />
        <Contact state = {this.state}/>
        <Footer />
      </div>
    );
  }
}
